const selectors = {
  component: "[data-cp]",
  image: "[data-cp-image]",
  format: "[data-cp-format]",
};

const initComponent = (component) => {
  const formats = component.querySelectorAll(selectors.format);
  const images = component.querySelectorAll(selectors.image);

  if (!formats.length || !images.length) return;

  const activate = (activeIndex) => {
    images.forEach((image, index) =>
      image.setAttribute("data-cp-image", index === activeIndex ? "active" : "")
    );
  };

  formats.forEach((format, activeIndex) =>
    format.addEventListener("click", () => activate(activeIndex))
  );

  activate(0);
};

document.addEventListener(
  "DOMContentLoaded",
  function () {
    const components = document.querySelectorAll(selectors.component);
    components?.forEach((component) => initComponent(component));
  },
  { once: true }
);
